// extracted by mini-css-extract-plugin
export default {"sozdat_text":"CreateProjectButton_firsttime_sozdat_text__rG6CT","create_button":"CreateProjectButton_firsttime_create_button__jwLZK"};